package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

/**
 * Message composer (Stitch `c8110400`): pill text field + teal circular send button. Send is a no-op
 * on blank input; the field keeps its own text — the caller owns [value]/[onValueChange] so drafts
 * survive recomposition. All copy ([placeholder], [sendContentDescription]) is passed in, localized.
 */
@Composable
fun ChatInputBar(
    value: String,
    onValueChange: (String) -> Unit,
    onSend: () -> Unit,
    placeholder: String,
    sendContentDescription: String,
    modifier: Modifier = Modifier,
    sending: Boolean = false,
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .background(AppTheme.colors.surface)
            .padding(horizontal = AppTheme.spacing.md, vertical = AppTheme.spacing.sm),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Box(
            modifier = Modifier
                .weight(1f)
                .background(AppTheme.colors.surfaceContainer, AppTheme.shapes.pill)
                .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.sm),
        ) {
            if (value.isEmpty()) {
                Text(
                    text = placeholder,
                    style = AppTheme.typography.bodyMd,
                    color = AppTheme.colors.onSurfaceVariant,
                )
            }
            BasicTextField(
                value = value,
                onValueChange = onValueChange,
                textStyle = AppTheme.typography.bodyMd.copy(color = AppTheme.colors.onSurface),
                modifier = Modifier.fillMaxWidth(),
                maxLines = 4,
            )
        }
        Box(
            modifier = Modifier
                .padding(start = AppTheme.spacing.sm)
                .size(AppTheme.sizes.minTouchTarget)
                .clip(AppTheme.shapes.pill)
                .background(AppTheme.colors.primaryContainer)
                .clickable(enabled = !sending && value.isNotBlank(), onClick = onSend),
            contentAlignment = Alignment.Center,
        ) {
            AppIcon(
                name = "send",
                tint = AppTheme.colors.onPrimary,
                contentDescription = sendContentDescription,
            )
        }
    }
}
